import React from "react";
import { Row, Col, Card, Input, Button, Modal } from "antd";
import { SearchOutlined, CloseOutlined, SyncOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import filter from "lodash/filter";
import sumBy from "lodash/sumBy";
import DefaultProductImage from "../../../../assets/images/no-image.svg";

const OMSOrdersModal = ({
  displayOMSOrderItemsModal,
  setDisplayOMSOrderItemsModal,
  omsOrderStatus,
  selectedOMSOrderStatus,
  selectedOrder,
  setSelectedOrder,
  handleOMSOrderStatusSelection,
  searchOrders,
  order,
  handleOrderSearchInput,
  handleOrderCard,
  omsOrderTotalPrice,
  currenciesList,
  tillData,
  data,
  handleOmsOrders,
  handleOMSStatusButton,
}) => {
  const setDefaultImage = (e) => {
    e.target.src = DefaultProductImage;
  };

  return (
    <Modal
      closable={false}
      footer={null}
      styles={{ body: { padding: 0, height: "100%" } }}
      open={displayOMSOrderItemsModal}
      // onCancel={handleAddOnModalClose}
      style={{ top: 50 }}
      width="90%"
    >
      <Row>
        <Col span={2}>
          <Row>
            {omsOrderStatus.map((statusItem, index) => (
              <Col
                span={24}
                style={
                  statusItem?.title === selectedOMSOrderStatus.title
                    ? data.posScreenStyles.omsOrdersModal.selectedOMSOrderStatusOptionsCol
                    : data.posScreenStyles.omsOrdersModal.omsOrderStatusOptionsCol
                }
                onClick={() => {
                  setSelectedOrder({});
                  handleOMSOrderStatusSelection(statusItem);
                }}
              >
                <img
                  src={statusItem?.title === selectedOMSOrderStatus.title ? statusItem?.imgSrc : statusItem?.selectedImgSrc}
                  alt={statusItem?.imgSrc}
                  style={{ height: "46px" }}
                />
                <h6
                  style={
                    statusItem?.title === selectedOMSOrderStatus.title
                      ? data.posScreenStyles.omsOrdersModal.selectedOMSStatusOptionName
                      : data.posScreenStyles.omsOrdersModal.omsStatusOptionName
                  }
                >
                  {statusItem?.title}
                </h6>
              </Col>
            ))}
          </Row>
        </Col>
        <Col span={6}>
          <Row>
            <Col span={24}>
              <p style={data.posScreenStyles.omsOrdersModal.manageOrders}>Manage Orders</p>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Input
                size="large"
                placeholder="Search Order No"
                value={order}
                onChange={(e) => {
                  handleOrderSearchInput(e.target.value);
                }}
                allowClear
                suffix={<SearchOutlined style={{ fontSize: "14px" }} />}
                className="orderIdInput"
                style={data.posScreenStyles.omsOrdersModal.orderIdInput}
              />
              <div style={{ backgroundColor: "#F5F5F7", marginTop: "3px" }}>
                <Scrollbars className="omsOrderCardsScroll">
                  {searchOrders && searchOrders.length > 0
                    ? filter(searchOrders, (searchItem) => searchItem.status === selectedOMSOrderStatus.statusValue)?.map((item, index) => (
                        <div>
                          <Card
                            styles={{ body: { padding: 10 } }}
                            style={
                              item.orderNo === selectedOrder.orderNo
                                ? data.posScreenStyles.omsOrdersModal.selectedOrderDetailsCard
                                : data.posScreenStyles.omsOrdersModal.orderDetailsCard
                            }
                            onClick={() => handleOrderCard(item)}
                          >
                            <p style={data.posScreenStyles.omsOrdersModal.orderIdValue}>OrderID: #{item.orderNo}</p>
                            <p style={data.posScreenStyles.omsOrdersModal.itemsNum}>
                              {item.noOfItems} items for {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              {sumBy(item.lineItems, "price").toFixed(2)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                            </p>
                            <p style={data.posScreenStyles.omsOrdersModal.dateCreated}>{item.dateCreated}</p>
                          </Card>
                          {/* <hr style={{ margin: 0, backgroundColor: "#FFFFFF11" }} /> */}
                        </div>
                      ))
                    : ""}
                </Scrollbars>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={16} style={{ padding: "3px 10px" }}>
          <Row>
            <Col span={12}>
              <p style={data.posScreenStyles.omsOrdersModal.omsCustTitle}>{tillData.tillAccess.csBunit.name}</p>
            </Col>
            <Col span={11} style={{ paddingTop: 5 }}>
              <p style={data.posScreenStyles.omsOrdersModal.closeIconP}>
                <SyncOutlined onClick={() => handleOmsOrders()} style={data.posScreenStyles.omsOrdersModal.closeIcon} />
              </p>
            </Col>
            <Col span={1} style={{ paddingTop: 5 }}>
              <p style={data.posScreenStyles.omsOrdersModal.closeIconP}>
                <CloseOutlined
                  onClick={() => {
                    setDisplayOMSOrderItemsModal(false);
                    // localStorage.setItem('orderDetails', "[]");
                  }}
                  style={data.posScreenStyles.omsOrdersModal.closeIcon}
                />
              </p>
            </Col>
          </Row>
          {Object.keys(selectedOrder).length > 0 ? (
            <>
              <Row style={{ marginTop: "2rem" }}>
                <Col span={12}>
                  <p style={data.posScreenStyles.omsOrdersModal.storeItems}>Store Items</p>
                </Col>
                <Col
                  span={12}
                  style={{
                    display:
                      selectedOMSOrderStatus.title === "Today's Orders" || selectedOMSOrderStatus.statusValue !== selectedOrder.status || selectedOrder.posOrders === "Y"
                        ? "none"
                        : "block",
                  }}
                >
                  <Button size="medium" style={data.posScreenStyles.omsOrdersModal.statusBtn} className="addButton" onClick={() => handleOMSStatusButton(selectedOrder)}>
                    <span style={data.posScreenStyles.omsOrdersModal.statusBtn.label}>
                      {selectedOrder.status === "NE" ? "Accept" : selectedOrder.status === "UP" ? "Prepared" : selectedOrder.status === "PK" ? "Completed" : "Accept"}
                    </span>
                  </Button>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={24}>
                  <Card styles={{ body: { padding: 0 } }} style={data.posScreenStyles.omsOrdersModal.omsOrderDetails}>
                    <Row
                      style={{
                        padding: 10,
                        paddingBottom: 5,
                        borderBottom: "1px solid #DCDCDC",
                      }}
                    >
                      <Col span={12}>
                        <p style={data.posScreenStyles.omsOrdersModal.omsOrderCustDetails}>OrderID. #{selectedOrder.orderNo}</p>
                        <p style={data.posScreenStyles.omsOrdersModal.omsOrderCustDetails}>{selectedOrder.customerName || "Anonymous"}</p>
                      </Col>
                      <Col span={12} style={{ textAlign: "right" }}>
                        <p style={data.posScreenStyles.omsOrdersModal.omsOrderCustDetails}>{selectedOrder.dateCreated}</p>
                        <p style={data.posScreenStyles.omsOrdersModal.omsOrderCustDetails}>{selectedOrder.noOfItems} Items</p>
                      </Col>
                    </Row>
                    <div style={{ borderBottom: "1px solid #DCDCDC" }}>
                      <Row
                        style={{
                          padding: 10,
                          paddingBottom: 0,
                        }}
                      >
                        <Col span={8}>
                          <p style={data.posScreenStyles.omsOrdersModal.tableHeadingName}>Item</p>
                        </Col>
                        <Col span={4}>
                          <p style={data.posScreenStyles.omsOrdersModal.tableHeadingQty}>Qty</p>
                        </Col>
                        <Col span={6}>
                          <p style={data.posScreenStyles.omsOrdersModal.tableHeadingPrice}>Price</p>
                        </Col>
                        <Col span={6}>
                          <p style={data.posScreenStyles.omsOrdersModal.tableHeadingPrice}>Total Price</p>
                        </Col>
                      </Row>
                      <Scrollbars className="orderDetailsTableScroll">
                        {selectedOrder?.lineItems?.map((productItem, index) => (
                          <Row
                            style={{
                              padding: 10,
                              paddingBottom: 0,
                            }}
                          >
                            <Col span={8}>
                              <p style={data.posScreenStyles.omsOrdersModal.tableDataName}>
                                <img onError={setDefaultImage} src={productItem.img} alt="" style={data.posScreenStyles.omsOrdersModal.productImg} />
                                <div
                                  style={{
                                    paddingLeft: 10,
                                    alignSelf: "center",
                                  }}
                                >
                                  {productItem.name}
                                  <br />
                                  <span style={data.posScreenStyles.omsOrdersModal.tableDataProdCode}>{productItem.productCode}</span>
                                </div>
                              </p>
                            </Col>
                            <Col span={4} style={{ paddingTop: 7 }}>
                              <p style={data.posScreenStyles.omsOrdersModal.tableDataQty}>x &nbsp;&nbsp;&nbsp; {productItem.quantity}</p>
                            </Col>
                            <Col span={6} style={{ paddingTop: 7 }}>
                              <p style={data.posScreenStyles.omsOrdersModal.tableDataPrice}>Rs.{productItem.price.toFixed(2)}</p>
                            </Col>
                            <Col span={6} style={{ paddingTop: 7 }}>
                              <p style={data.posScreenStyles.omsOrdersModal.tableDataPrice}>Rs.{productItem.price.toFixed(2)}</p>
                            </Col>
                          </Row>
                        ))}
                      </Scrollbars>
                    </div>
                    <Row
                      style={{
                        padding: 10,
                      }}
                    >
                      <Col span={12} />
                      <Col span={6}>
                        <p style={data.posScreenStyles.omsOrdersModal.subTotalTaxes}>Sub Total</p>
                        <p style={data.posScreenStyles.omsOrdersModal.subTotalTaxes}>Taxes</p>
                        <p style={data.posScreenStyles.omsOrdersModal.total}>Total</p>
                      </Col>
                      <Col span={6}>
                        <p style={data.posScreenStyles.omsOrdersModal.subTotalTaxes}>Rs.{(omsOrderTotalPrice || 0).toFixed(2)}</p>
                        <p style={data.posScreenStyles.omsOrdersModal.subTotalTaxes}>Rs.0</p>
                        <p style={data.posScreenStyles.omsOrdersModal.total}>Rs.{(omsOrderTotalPrice || 0).toFixed(2)}</p>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default OMSOrdersModal;
